import GeraSenha from './modules/GeraSenha'
import Embaralha from './modules/Embaralha'

import './assets/css/style.css'

const gera = new GeraSenha
gera.addNum()
gera.addUppercase()
gera.addLowercase()
gera.addSymbol()

const embaralha = new Embaralha
embaralha.embaralhar()